export { default as default } from './FullScreen';
